var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-01",
    clipPath: "url(#clip0_7464_30838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.44002 15.2778C2.47764 14.9331 2.49645 14.7608 2.54827 14.5997C2.59425 14.4567 2.65934 14.3206 2.74177 14.1951C2.83467 14.0536 2.95701 13.9308 3.20169 13.6852L14.1857 2.65879C15.1044 1.73655 16.5968 1.73368 17.5191 2.65238C18.4413 3.57108 18.4442 5.06346 17.5255 5.9857L6.54144 17.0121C6.29676 17.2577 6.17442 17.3805 6.03329 17.474C5.90808 17.5569 5.77225 17.6225 5.62947 17.669C5.46853 17.7215 5.29628 17.7409 4.95178 17.7799L2.13208 18.0987L2.44002 15.2778Z",
    stroke: "#F7F9F9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7464_30838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.015625 1.01929) rotate(-0.110297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLight);
export default __webpack_public_path__ + "static/media/edit-light.efc1ef8bf1a307009b2530785a1992be.svg";
export { ForwardRef as ReactComponent };